import { getTimeseriesConfig, saveTimeseriesConfig } from '@/api/api.js';

// 'Infinity' non è JSON valido (JSON.stringify(Infinity) => null): 'null' rappresenta
// "nessun limite" nel JSON persistito, al posto di Infinity usato nel file originale.
// domain_id è un riferimento "soft" a public._domain.domain_id (nessuna FK reale possibile
// su un campo dentro una colonna jsonb) — null finché non assegnato manualmente nel form.
export const DEFAULT_CONFIG = {
  WORKSPACES: [
    {
      id: 'HRS_ITA_1KM_1H',
      domain_id: null,
      resolution: 'hourly',
      priority: 1,
      timeRange: { past: null, future: 0 },
      layers: ['TC2M_HOURLY', 'PREC_HOURLY', 'SLP_HOURLY']
    },
    {
      id: 'HNS_ITA_1KM_1H',
      domain_id: null,
      resolution: 'hourly',
      priority: 2,
      timeRange: { past: 1, future: 4 },
      layers: ['TC2M_HOURLY', 'PREC_HOURLY']
    },
    {
      id: 'HFS_ITA_4KM_1H',
      domain_id: null,
      resolution: 'hourly',
      priority: 3,
      timeRange: { past: 1, future: 360 },
      layers: ['TC2M_HOURLY', 'PREC_HOURLY', 'SLP_HOURLY']
    },
    {
      id: 'HRS_ITA_1KM_1D',
      domain_id: null,
      resolution: 'daily',
      priority: 1,
      timeRange: { past: null, future: 0 },
      layers: ['TMIN-DAILY', 'TMAX-DAILY', 'TMED-DAILY', 'PREC-DAILY']
    },
    {
      id: 'HFS_ITA_4KM_1D',
      domain_id: null,
      resolution: 'daily',
      priority: 3,
      timeRange: { past: 1, future: 360 },
      layers: ['TMIN-DAILY', 'TMAX-DAILY', 'TMED-DAILY', 'PREC-DAILY']
    },
    {
      id: 'HRS_EUR_5KM_1H',
      domain_id: null,
      resolution: 'hourly',
      priority: 1,
      timeRange: { past: null, future: 0 },
      layers: ['TC2M_HOURLY', 'PREC_HOURLY', 'SLP_HOURLY']
    },
    {
      id: 'HFS_EUR_12KM_1H',
      domain_id: null,
      resolution: 'hourly',
      priority: 3,
      timeRange: { past: 1, future: 360 },
      layers: ['TC2M_HOURLY', 'PREC_HOURLY', 'SLP_HOURLY']
    }
  ]
};

const toFormState = raw => ({
  workspaces: (raw.WORKSPACES || []).map(ws => ({
    id: ws.id,
    domain_id: ws.domain_id,
    resolution: ws.resolution,
    priority: ws.priority,
    past: ws.timeRange ? ws.timeRange.past : null,
    future: ws.timeRange ? ws.timeRange.future : null,
    layers: ws.layers || []
  }))
});

const toRawConfig = workspaces => ({
  WORKSPACES: workspaces.map(ws => ({
    id: ws.id,
    domain_id: ws.domain_id,
    resolution: ws.resolution,
    priority: ws.priority,
    timeRange: { past: ws.past, future: ws.future },
    layers: ws.layers
  }))
});

export const state = {
  workspaces: [],
  updatedAt: null,
  loaded: false
};

export const mutations = {
  SET_TIMESERIES_CONFIG(state, { workspaces, updatedAt }) {
    state.workspaces = workspaces;
    state.updatedAt = updatedAt;
    state.loaded = true;
  }
};

export const actions = {
  async storeTimeseriesConfig({ commit, dispatch }) {
    try {
      const resp = await getTimeseriesConfig();
      const result = resp.data.getTimeseriesConfig;

      if (!result || !result.config) {
        commit('SET_TIMESERIES_CONFIG', { ...toFormState(DEFAULT_CONFIG), updatedAt: null });

        return;
      }

      const parsed = JSON.parse(result.config);

      commit('SET_TIMESERIES_CONFIG', { ...toFormState(parsed), updatedAt: result.updated_at });
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeTimeseriesConfig',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
      commit('SET_TIMESERIES_CONFIG', { ...toFormState(DEFAULT_CONFIG), updatedAt: null });
    }
  },

  loadDefaultTimeseriesConfig({ commit }) {
    commit('SET_TIMESERIES_CONFIG', { ...toFormState(DEFAULT_CONFIG), updatedAt: null });
  },

  async storeSaveTimeseriesConfig({ commit, dispatch }, { workspaces }) {
    try {
      const rawConfig = toRawConfig(workspaces);
      const resp = await saveTimeseriesConfig(JSON.stringify(rawConfig));
      const result = resp.data.saveTimeseriesConfig;

      commit('SET_TIMESERIES_CONFIG', {
        workspaces,
        updatedAt: result ? result.updated_at : null
      });
      dispatch(
        'storeToastMessage',
        {
          text: 'Timeseries config saved',
          type: 'success'
        },
        { root: true }
      );
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeSaveTimeseriesConfig',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  }
};

export const getters = {};
